import { render } from "./NavLink.vue?vue&type=template&id=b74951a6&ts=true"
import script from "./NavLink.vue?vue&type=script&lang=ts"
export * from "./NavLink.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Navigation/NavLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b74951a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b74951a6', __exports__)) {
    console.log('reload')
    api.reload('b74951a6', __exports__)
  }
  
  module.hot.accept("./NavLink.vue?vue&type=template&id=b74951a6&ts=true", () => {
    console.log('re-render')
    api.rerender('b74951a6', render)
  })

}


export default __exports__